module.exports = __webpack_public_path__ + "img/2.2e5ee10e.png";